import { adminTypes } from "app/redux/type/adminTypes";

const initialState = {
  isLoading: false,
  queryList: null,
  queryDetails: null,
  msg: "",
};
export const queryReducer = (state = initialState, action) => {
  switch (action.type) {
    case adminTypes.GET_QUERY_DATA_PENDING:
      return {
        ...state,
        isLoading: action.isLoading,
        msg: "",
      };
    case adminTypes.GET_QUERY_DATA_SUCCESS:
      return {
        ...state,
        isLoading: action.isLoading,
        queryList: action.payload,
        msg: "",
      };
    case adminTypes.GET_QUERY_DATA_FAILED:
      return {
        ...state,
        isLoading: action.isLoading,
        queryList: action.payload,
        msg: action.msg,
      };
    case adminTypes.GET_QUERY_DETAIL_PENDING:
      return {
        ...state,
        isLoading: action.isLoading,
        msg: "",
      };
    case adminTypes.GET_QUERY_DETAIL_SUCCESS:
      return {
        ...state,
        isLoading: action.isLoading,
        queryDetails: action.payload,
        msg: "",
      };
    case adminTypes.GET_QUERY_DETAIL_FAILED:
      return {
        ...state,
        isLoading: action.isLoading,
        queryDetails: action.payload,
        msg: action.msg,
      };
    default:
      return state;
  }
};
